import React from "react";
import { UsersIcon } from "@heroicons/react/solid";
import { experience } from "./data";

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Typography from '@mui/material/Typography';

export default function Experience() {
    let experienceItems = []
    experience.forEach(element => {
        experienceItems.push(
            <TimelineItem key={element.time}>
                <TimelineOppositeContent
                    sx={{ m: 'auto 0' }}
                    align="right"
                    variant="body2"
                    color="white"
                >{element.time}
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineConnector />
                    <TimelineDot>
                        {element.icon}
                    </TimelineDot>
                    <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: '10px', px: 2 }}>
                    <Typography variant="subtitle1" component="span">
                        {element.position}
                    </Typography>
                    <Typography variant="subtitle2" color="#07b327">
                        <a href={element.url} target="_blank" rel="noopener noreferrer">
                            {element.company}
                        </a>
                        </Typography>
                    <Typography variant="body2" flexShrink alignContent>{element.details}</Typography>
                </TimelineContent>
            </TimelineItem>
        )
    })

    return (
        <section id="experience" className="relative">
            <div className="container px-5 py-10 mx-auto text-center">
                <UsersIcon className="w-10 inline-block mb-4" />
                <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4">
                    Experience &amp; Education
                </h1>
            </div>
            <div>
                <Timeline position="alternate">
                    {experienceItems}
                </Timeline>
            </div>
        </section>
    );
}